import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class ButtonReleasedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On MD Button Released';
        this.id = 'node_button_released';
        this.icon = 'GiClick';
        this.linkedFeature = 'general';
        this.requirements = ['md_button'];

        this.outputs = [
            {
                name: 'Released',
                portId: 'on_button_released',
                params: [
                    {
                        name: 'pressed_time',
                        dataType: TibboDataType.BYTE,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'on_button_released');
        blocks.push({
            location: 'on_button_released',
            blockType: BlockType.CODE,
            id: 'on_button_released_setup',
            template: 'dim pressed_time as byte = button.time',
        });
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: 'on_button_released',
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `'****${link.getSourceId()}****'`,
            });

            if (project.runtime === 'simulator') {
                return [
                    {
                        location: 'GLOBAL_DECLARATIONS',
                        blockType: BlockType.CODE,
                        id: 'buttonPressedTime',
                        template: `
let buttonPressedTime;
let pressed_time;
                        `,
                    },
                    {
                        location: 'on_button_pressed',
                        blockType: BlockType.CODE,
                        id: `node_${link.getSourceId()}_pressed_time_init`,
                        template: `
buttonPressedTime = new Date().getTime();`,
                    },
                    {
                        location: 'on_button_released',
                        blockType: BlockType.CODE,
                        template: `
if (buttonPressedTime) {
    pressed_time = (new Date().getTime() - buttonPressedTime) / 1000 * 2;
}
/****${link.getSourceId()}****/`,
                    },
                ];
            }
        }

        return blocks;
    }

    getDetails(): string {
        return `
This block is triggered when the **MD** button is released (or the **MD** line is pulled HIGH on modules without the button).

This is useful for detecting long presses.`;
    }
}
